import { pickBy } from 'lodash-es';
import { useSearchParams } from 'react-router-dom';

import { isString } from '@util/data/is-exist';

export const useSearchLocation = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const searchData = Object.fromEntries(searchParams.entries());

  const setSearch = (data: Record<string, string | undefined>) =>
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    setSearchParams(pickBy({ ...searchData, ...data }, isString));

  return [searchData, setSearch] as const;
};
